import { useEffect, useState } from "react";
import { buildGlobalStylesComponent } from "../globalStyles";
import { getSubdomain } from "services/urlService";
import { getCustomizationLocalStorage } from "services/customizationService";
import { LS_CUSTOMIZATION_SET_EVENT_KEY } from "constants/constants";
import i18n from "i18next";

const GlobalStylesWrapper = () => {
    const subdomain = getSubdomain();
    const [currentTheme, setCurrentTheme] = useState<string | null>(
        getCustomizationLocalStorage(),
    );

    const textDirection = i18n.dir(i18n.language);
    const rtlNotistackOverrides = `
        .notistack-MuiContent {
            display: block;
        }
        
        .notistack-MuiContent #notistack-snackbar {
            text-align: end;
            display: block;
            margin-right: 1.5rem;
        }
    `;
    const notistackOverrides =
        "rtl" === textDirection ? rtlNotistackOverrides : null;

    useEffect(() => {
        if (!subdomain) return;

        const handleCustomizationSet = () => {
            const customization = getCustomizationLocalStorage();
            if (customization) {
                setCurrentTheme(customization);
            }
        };

        window.addEventListener(
            LS_CUSTOMIZATION_SET_EVENT_KEY,
            handleCustomizationSet,
        );

        return () => {
            window.removeEventListener(
                LS_CUSTOMIZATION_SET_EVENT_KEY,
                handleCustomizationSet,
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const GlobalStyle = buildGlobalStylesComponent({
        overrides: currentTheme,
        notistackOverrides,
    });

    return <GlobalStyle />;
};

export default GlobalStylesWrapper;
